export default [
    // {
    //     path: '/building/building',
    //     name: 'BuildingBuilding',
    //     component: () => import(/* webpackChunkName: "building-building" */ '@/views/building/building/Building.vue'),
    //     meta: {
    //         isAuth: true,
    //         isFrame: true,
    //         menuActiveTag: '/building/building',
    //         rbacTag: 'building:building',
    //     }
    // },
    {
        path: '/building/room',
        name: 'BuildingRoom',
        component: () => import(/* webpackChunkName: "building-room" */ '@/views/building/room/Room.vue'),
        meta: {
            isAuth: true,
            isFrame: true,
            menuActiveTag: '/building/room',
            rbacTag: 'building:room',
        }
    },
    {
        path: '/building/type',
        name: 'BuildingType',
        component: () => import(/* webpackChunkName: "building-type" */ '@/views/building/buildType/BuildType.vue'),
        meta: {
            isAuth: true,
            isFrame: true,
            menuActiveTag: '/building/type',
            rbacTag: 'build:type:rule',
        }
    },
    {
        path: '/work/type',
        name: 'WorkType',
        component: () => import(/* webpackChunkName: "work-type" */ '@/views/building/workType/WorkType.vue'),
        meta: {
            isAuth: true,
            isFrame: true,
            menuActiveTag: '/work/type',
            rbacTag: 'work:type:rule',
        }
    },
];